import { SegmentHeader } from "@/components/campaign/basic/SegmentHeader";
import { TriggerCards } from "@/components/campaign/TriggerCards";
import { createFileRoute, linkOptions } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_dashboard/campaigns/setup/planning/triggers/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const context = Route.useRouteContext();
  const stepper = context.useStepper();

  if (stepper.context.planning?.type !== "Triggered")
    throw Error("Stepper context must be of type Triggered");

  return (
    <div className="flex w-full flex-col gap-y-10">
      <SegmentHeader
        title="Salgstriggers"
        description="Vælg de salgstriggere der gør, at en virksomhed i din målgruppe bliver til et lead."
      />

      <TriggerCards
        triggers={stepper.context.planning?.triggers}
        buildTriggerLink={(triggerId) =>
          linkOptions({
            from: Route.fullPath,
            to: "/campaigns/setup/planning/triggers/$triggerId",
            params: { triggerId },
          })
        }
      />
    </div>
  );
}
